/**
 * Given an array of properties and transform to collection data for collection tables
 * @param  {Array} property_summary to property data
 * @return {Object} collection data for collection tables
 */
export const getMonopolyCollections = property_summary => {
    let collections = [];

    for (const [key, value] of Object.entries(property_summary)) {
        collections.push(
            {
                'color' : key.split("_")[0].toLowerCase(),
                'base_entries' : parseInt(value.base_entries, 10) ?? 0,
                'bonus_entries' : (value.bonus_entries) ? parseInt(value.bonus_entries, 10) : 0,
                'tickets' : (value.Tickets) ? value.Tickets : 0,
                'length' : (value.Tickets && Array.isArray(value.Tickets)) ? value.Tickets.length : 0,
            }
        );
    }

    return collections;
};
